export const siteUrl = 'https://www.phonetoo.cn'

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '温州市宏图机电有限公司',
  url: siteUrl,
  email: 'phonetoo@126.com',
  telephone: '+86-153-7282-9178',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '海滨街道文化路18号',
    addressLocality: '温州市',
    addressRegion: '浙江省',
    addressCountry: 'CN',
  },
}
